import { createAction, props } from '@ngrx/store';
import { FieldGroup } from '../_models';

// Action types
export const loadFieldGroups = createAction('[FieldGroup] Load FieldGroups');
export const loadFieldGroupsSuccess = createAction(
  '[FieldGroup] Load FieldGroups Success',
  props<{ fieldGroups: FieldGroup[] }>()
);
export const loadFieldGroupsFailure = createAction(
  '[FieldGroup] Load FieldGroups Failure',
  props<{ error: any }>()
);

export const addFieldGroup = createAction(
  '[FieldGroup] Add FieldGroup',
  props<{ fieldGroup: FieldGroup }>()
);
export const addFieldGroupSuccess = createAction(
  '[FieldGroup] Add FieldGroup Success',
  props<{ fieldGroup: FieldGroup }>()
);
export const addFieldGroupFailure = createAction(
  '[FieldGroup] Add FieldGroup Failure',
  props<{ error: any }>()
);

export const updateFieldGroup = createAction(
  '[FieldGroup] Update FieldGroup',
  props<{ fieldGroup: FieldGroup }>()
);
export const updateFieldGroupSuccess = createAction(
  '[FieldGroup] Update FieldGroup Success',
  props<{ fieldGroup: FieldGroup }>()
);
export const updateFieldGroupFailure = createAction(
  '[FieldGroup] Update FieldGroup Failure',
  props<{ error: any }>()
);

export const deleteFieldGroup = createAction(
  '[FieldGroup] Delete FieldGroup',
  props<{ id: number }>()
);
export const deleteFieldGroupSuccess = createAction(
  '[FieldGroup] Delete FieldGroup Success',
  props<{ id: number }>()
);
export const deleteFieldGroupFailure = createAction(
  '[FieldGroup] Delete FieldGroup Failure',
  props<{ error: any }>()
);
